<div class="trailer-requests">
  @if (!isLoading ) {
<div>
    @if (mappedRequests?.length === 0) {
<div>
      {{localize(langSection.HomePage, langText.NoResultsMatched)}}
    </div>
}
    @if (mappedRequests?.length > 0) {
<div>
      @for (request of mappedRequests; track trackByFunction(i, request); let i = $index) {
<div class="m-0">
        <div class="trailer-request ms-0" [ngClass]="request.attentionNeeded ? 'attention-needed' : ''">
          <div class="section-menu">
            @if (showCommentsIndicator(request)) {
<span class="comments-indicator icon"></span>
}
            <div class="request-links">
              <a href=""
                (click)="openModal('comments', request); $event.preventDefault()">{{localize(langSection.TrailerCard,
                langText.Comments)}}</a>
              <a href=""
                (click)="openModal('contact', request); $event.preventDefault()">{{localize(langSection.TrailerCard,
                langText.Contact)}}</a>
              <a href="#" routerLink=""
                [queryParams]="{ path: 'request', requestid: request.requestId }">{{localize(langSection.TrailerCard,
                langText.Details)}}</a>
              @if (!(request.isSoftDeleted && (request.attentionNeeded || request.requestStatus === 'Pending'))) {
<a href="#"
               
                [ngClass]="showLink(request)"
                (click)="openModal('cancel', request); $event.preventDefault()">{{localize(langSection.Term,
                langText.Cancel)}}</a>
}
              @if (!(request.isSoftDeleted && (request.attentionNeeded || request.requestStatus === 'Pending')) && !(request.driverCreated)) {
<a href="#"
               
                [ngClass]="showLink(request)" routerLink=""
                [queryParams]="{ path: 'edit-request', requestid: request.requestId }">{{localize(langSection.Term,
                langText.Edit)}}</a>
}
              @if (request.driverCreated) {
<span class="driver-created-request">*
                {{localize(langSection.TrailerCard,
                langText.DriverCreatedRequest)}}</span>
}
            </div>
            @if (request.driverCreated) {
<div class="driver-created-request-sm">*
              {{localize(langSection.TrailerCard,
              langText.DriverCreatedRequest)}}</div>
}
          </div>
          <div class="section-info">
            <request-info [request]="request"></request-info>
          </div>
          <div class="section-progress" [ngClass]="request.attentionNeeded ? 'justify-content-center' : ''">
            <div class="text-center" [ngClass]="request.peakSeasonWarning ? '' : ''">
              @if (!request.attentionNeeded) {
<request-progress [request]="request"></request-progress>
}
              @if (request.attentionNeeded) {
<request-rejection [request]="request"></request-rejection>
}
            </div>
          </div>
          @if (request.requestType != 'REALIGN') {
<div class="section-trailers">
            <request-trailer [request]="request"></request-trailer>
          </div>
}
        </div>
      </div>
}
    </div>
}
  </div>
} @else {

    {{localize(langSection.Term, langText.Loading)}}
  
}
  
</div>